import { isValidObject } from "../../Services/validators";
import { generateColorMap } from "./Constants";

export const locationTableHeadings = [
  {
    title: "PCT #",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "WARD",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "ZONE",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "ADDRESS",
    maxWidth: "200px",
    textAlign: "left"
  },
  {
    title: "CATEGORY",
    width: "120px",
    textAlign: "left"
  },
  {
    title: "STATUS",
    width: "100px",
    textAlign: "left"
  },
  {
    title: "LAST EMP. CAP.",
    width: "120px",
    textAlign: "left"
  },
  {
    title: "MANPOWER",
    width: "100px",
    textAlign: "left"
  },
  {
    title: "RESOLVED COMP.S",
    width: "150px",
    textAlign: "left"
  },
  {
    title: "UNRESOLVED COMP.S",
    width: "150px",
    textAlign: "right"
  }
  // {
  //   title: "COMPLETED PROCEDURES",
  //   width: "200px",
  //   textAlign: "center",
  // },
];

export const exportLocationTableHeadings = [
  {
    title: "PCT #",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "WARD",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "ZONE",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "ADDRESS",
    maxWidth: "200px",
    textAlign: "left"
  },
  {
    title: "CATEGORY",
    width: "120px",
    textAlign: "left"
  },
  {
    title: "STATUS",
    width: "100px",
    textAlign: "left"
  }  // },
];

export const locationTableField = (data) => {
  switch (data) {
    case "SI.No":
      return "serialNo";
    case "PCT #":
      return "PCTNo";
    case "WARD":
      return "ward";
    case "ADDRESS":
      return "location";
    case "ZONE":
      return "zone";
    case "CATEGORY":
      return "category";
    case "STATUS":
      return "operationalStatusState";
    case "RESOLVED COMP.S":
      return "totalClosedCompliant";
    case "UNRESOLVED COMP.S":
      return "totalOpenCompliant";
    case "COMPLETED PROCEDURES":
      return "totalCompletedProcedure";
    case "MANPOWER":
      return "totalManPower";
    case "LAST EMP. CAP.":
      return "totalManPowerCapacity";
    default:
      return data.toLowerCase();
  }
};

export const locationFilterData = (props) => [
  {
    key: "category",
    title: "CATEGORY",
    multiple: true,
    options: ["community", "institutional", "publicSpace", "transitArea"]
  },
  {
    key: "dateRange",
    title: "DATE RANGE",
    multiple: false,
    options: ["Lifetime", "Today", "Last 7 days", "Last 30 days", "Select Date"]
  },
  {
    key: "status",
    title: "STATUS",
    multiple: true,
    options: ["Active", "Inactive"]  
  },
  {
    key: "ward",
    title: "WARD",
    multiple: true,
    options: props.wards || []
  },
  {
    key: "zone",
    title: "ZONE",
    multiple: true,
    options: props.zones || []
  }
];

export const defaultLocationFilter = {
  category: [],
  zone: [],
  ward: [],
  status: [],
  dateRange: {
    type: "Today",
    from: new Date().toISOString().split("T")[0],
    to: new Date().toISOString().split("T")[0]
  }
};

export const getLocationIdWithPctNo = (locations, pctNos) => {
  const pctNoSet = new Set(pctNos);
  return locations
    .filter((location) => pctNoSet.has(location?.PCTNo))
    .map((location) => location.documentId);
};

export const getZoneWiseLocationsChartData = (count) => {
  if (!isValidObject(count)) {
    return {
      labels: [],
      datasets: [
        {
          label: "Complaint Zone",
          data: [],
          backgroundColor: [],
          borderColor: [],
          borderWidth: 2,
          borderRadius: 0,
          spacing: 2
        }
      ],
      defaultValue: {
        label: "TOTAL LOCATIONS",
        value: 0
      }
    };
  }

  const backgroundColor = [];
  const borderColor = [];

  Object.values(count).forEach((_value, index) => {
    const color = generateColorMap()[index] || generateColorMap().default;
    backgroundColor.push(color.bg);
    borderColor.push(color.border);
  });

  return {
    labels: Object.keys(count).map((zone) => `Zone ${zone}`),
    datasets: [
      {
        label: "Complaint Zones",
        data: Object.values(count),
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 2,
        borderRadius: 0,
        spacing: 2
      }
    ],
    defaultValue: {
      label: "TOTAL LOCATIONS",
      value: Object.values(count).reduce((sum, value) => sum + value, 0)
    }
  };
};

export const getAttendanceChartData = (count) => {
  const labels = ["PRESENT", "ABSENT"];
  const data = [count?.present || 0, count?.absent || 0];

  return {
    labels,
    datasets: [
      {
        label: "Today Attendance",
        data,
        backgroundColor: [
          `${getComputedStyle(document.documentElement).getPropertyValue(
            "--secondaryColor"
          )}`,
          `${getComputedStyle(document.documentElement).getPropertyValue(
            "--tertiaryColor"
          )}`
        ],
        borderColor: [
          `${getComputedStyle(document.documentElement).getPropertyValue(
            "--secondaryColor"
          )}`,
          `${getComputedStyle(document.documentElement).getPropertyValue(
            "--tertiaryColor"
          )}`
        ],
        borderWidth: 2,
        borderRadius: 0,
        spacing: 2
      }
    ],
    defaultValue: {
      label: "TOTAL EMPLOYEES",
      value: count?.total || 0
    }
  };
};

export const getLocationOperationalStatusChartData = (locationsData) => {
 if (!isValidObject(locationsData)) {
  return {
    labels: ["Active", "Inactive"],
    datasets: [{
      data: [0, 0],
      backgroundColor: ["#20C74F", "#D0405A"],
      borderColor: ["transparent"],
      borderWidth: 0,
      borderRadius: 0,
      spacing: 2
    }],
    defaultValue: {
      label: "TOTAL LOCATIONS",
      value: 0
    }
  };
}

  const locations = Object.values(locationsData);
  const activeCount = locations.filter(
    (l) => l?.operationalStatus?.state !== "Inactive"
  ).length;
  const inactiveCount = locations.length - activeCount;

  return {
    labels: ["Active", "Inactive"],
   datasets: [{
  data: [activeCount, inactiveCount],
  backgroundColor: ["#20C74F", "#D0405A"],
  borderColor: ["transparent"],
  borderWidth: 0,
  borderRadius: 0,
  spacing: 1
}],
    defaultValue: {
      label: "TOTAL LOCATIONS",
      value: locations.length
    }
  };
};